import ChangeLog from '../../change-log';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer bg-body-tertiary p-3">
      <div className="container text-center">
        <ul className="list-inline footer-links mb-1">
          <li className="list-inline-item">
            <Link to="/privacy" className="nav-item nav-link">
              Privacy Policy
            </Link>
          </li>
          <li className="list-inline-item">
            <Link to="/contribute" className="nav-item nav-link">
              Contribute
            </Link>
          </li>
          <li className="list-inline-item">
            <Link to="/meettheteam" className="nav-item nav-link">
              Meet the Team
            </Link>
          </li>
        </ul>
      </div>
      <div className="container text-center text-muted">
        <small>
          {process.env.REACT_APP_TTNAME} {ChangeLog[0].version}{' '}
          {process.env.REACT_APP_TTVERSION} - &copy; {new Date().getFullYear()}{' '}
          Andy Eder
        </small>
      </div>
    </footer>
  );
};

export default Footer;
